<template>
    <div>
        <v-overlay absolute :value="overlay" :opacity="overlayOpacity">
            <v-row>
                <v-col>
                    <w-btn-delete
                        :show="deleteAction"
                        :loading="loading"
                        @press="remove"
                    />
                    <w-btn-archive
                        :show="archiveAction"
                        :loading="loading"
                        @press="archive"
                    />
                    <w-btn-unarchive
                        :show="unarchiveAction"
                        :loading="loading"
                        @press="unarchive"
                    />
                    <w-btn-activate
                        :show="activateAction"
                        :loading="loading"
                        @press="activate"
                    />
                    <w-btn-deactivate
                        :show="deactivateAction"
                        :loading="loading"
                        @press="deactivate"
                    />
                    <w-btn-launch
                        :show="launchAction"
                        :loading="loading"
                        @press="launch"
                    />
                     <w-btn-lock
                        :show="lockAction"
                        :loading="loading"
                        @press="lock"
                    />
                    <w-btn-unlock
                        :show="unlockAction"
                        :loading="loading"
                        @press="unlock"
                    />
                </v-col>
                <v-col>
                    <w-btn
                        icon="mdi-close"
                        color="teal"
                        :text="$t('common.close')"
                        :loading="loading"
                        @press="cancel"
                    />
                </v-col>
            </v-row>
        </v-overlay>
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData";

export default {
    name: "WOverlay",
    props: {
        loading: Boolean,
        overlay: Boolean,
        deleteAction: Boolean,
        archiveAction: Boolean,
        unarchiveAction: Boolean,
        activateAction: Boolean,
        deactivateAction: Boolean,
        launchAction: Boolean,
        lockAction: Boolean,
        unlockAction: Boolean,
    },
    emits: ["remove", "archive", "unarchive", "activate", "deactivate", "launch", "lock", "unlock", "cancel"],
    setup(props, {emit}) {
        const {overlayOpacity} = useSharedData();

        function remove() {
            emit('remove');
        }

        function archive() {
            emit('archive');
        }

        function unarchive() {
            emit('unarchive');
        }

        function activate() {
            emit('activate');
        }

        function deactivate() {
            emit('deactivate');
        }

        function launch() {
            emit('launch');
        }

        function lock() {
            emit('lock');
        }

        function unlock() {
            emit('unlock');
        }

        function cancel() {
            emit('cancel');
        }

        return {
            overlayOpacity,
            remove,
            archive,
            unarchive,
            activate,
            deactivate,
            launch,
            lock,
            unlock,
            cancel,
        }
    }
}
</script>

<style scoped>

</style>